import { createNotification } from "react-redux-notify";
import { select, put, takeLatest, all } from "redux-saga/effects";

import api from "../../Environment";
import { FETCH_NOTIFICATIONS_START, FETCH_NOTIFICATION_BELL_COUNT_START } from "../actions/ActionConstant";
import { getErrorNotificationMessage } from "../../components/helper/NotificationMessage";

import {
  fetchNotificationBellCountSuccess,
  fetchNotificationsFailure,
  fetchNotificationsSuccess,
} from "../actions/NotificationAction";
import { fetchMessageAndNotificationCountStart } from "../actions/ChatAction";
import { hideErrorComponent, showErrorComponent } from "../actions/ComponentAction";

function* fetchNotificationAPI() {
  try {
    const inputData = yield select(
      (state) => state.notification.notification.inputData
    );

    const pagination = yield select(
      (state) => state.notification.notification.pagination
    )

    const response = yield api.postMethod(
      "bell_notifications_index",
      {...inputData, ...pagination}
    );
    if (response.data.success) {
      yield put(fetchNotificationsSuccess(response.data.data));
      yield put(fetchMessageAndNotificationCountStart())
    } else {
      yield put(fetchNotificationsFailure(response.data.error));
      const notificationMessage = getErrorNotificationMessage(
        response.data.error
      );
      yield put(createNotification(notificationMessage));
    }
  } catch (error) {
    yield put(fetchNotificationsFailure(error));
    if(error?.response?.status !== 400){
      yield put(showErrorComponent({error:error, status:error?.response?.status ?  error?.response?.status : 500}));
    }
    const notificationMessage = getErrorNotificationMessage(error.message);
    yield put(createNotification(notificationMessage));
  }
}

function* fetchNotificationCount() {
  try {
    const response = yield api.postMethod(
      "unread_bell_notifications_count", {}
    );

    if (response.data.success) {
      yield put(fetchNotificationBellCountSuccess(response.data.data));
    yield put(hideErrorComponent());
    } else {
      const notificationMessage = getErrorNotificationMessage(
        response.data.error
      );
      yield put(createNotification(notificationMessage));
    }
  } catch (error) {
    const notificationMessage = getErrorNotificationMessage(error.message);
    if(error?.response?.status !== 400){
      yield put(showErrorComponent({error:error, status:error?.response?.status ?  error?.response?.status : 500}));
    }
    yield put(createNotification(notificationMessage));
  }
}

export default function* pageSaga() {
  yield all([
    yield takeLatest(FETCH_NOTIFICATIONS_START, fetchNotificationAPI),
    yield takeLatest(FETCH_NOTIFICATION_BELL_COUNT_START, fetchNotificationCount)
  ]);
}
